import { useContext } from 'react';
import { ToastContext } from '../context/ToastContext';

/**
 * Hook to access toast notifications
 * @returns {{ addToast, removeToast, success, error, info, award, toasts }}
 */
export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
